const AddIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6673 8.83325C11.6673 9.01992 11.5207 9.16659 11.334 9.16659H8.66732V11.8333C8.66732 12.0199 8.52065 12.1666 8.33398 12.1666H7.66732C7.48065 12.1666 7.33398 12.0199 7.33398 11.8333V9.16659H4.66732C4.48065 9.16659 4.33398 9.01992 4.33398 8.83325V8.16659C4.33398 7.97992 4.48065 7.83325 4.66732 7.83325H7.33398V5.16659C7.33398 4.97992 7.48065 4.83325 7.66732 4.83325H8.33398C8.52065 4.83325 8.66732 4.97992 8.66732 5.16659V7.83325H11.334C11.5207 7.83325 11.6673 7.97992 11.6673 8.16659V8.83325Z"
      fill="#526363"
    />
    <path
      d="M7.99398 1.83325C4.31398 1.83325 1.33398 4.81992 1.33398 8.49992C1.33398 12.1799 4.31398 15.1666 7.99398 15.1666C11.674 15.1666 14.6673 12.1799 14.6673 8.49992C14.6673 4.81992 11.6807 1.83325 7.99398 1.83325ZM7.99398 13.8333C5.04732 13.8333 2.66065 11.4466 2.66065 8.49992C2.66065 5.55325 5.05398 3.16659 8.00065 3.16659C10.9473 3.16659 13.334 5.55325 13.334 8.49992C13.334 11.4466 10.9473 13.8333 8.00065 13.8333H7.99398Z"
      fill="#526363"
    />
  </svg>
);

export default AddIcon;
